import React, {Component} from 'react'

export default class Rank {

    static OGA_OWNER = "0 - Propietario";
    static VISIONARY = "1 - Visionario";
    static ENTERPRISING = "2 - Emprendedor";
    static EXECUTIVE = "3 - Ejecutivo";
    static MANAGER = "4 - Manager";
    static BRONZE_MANAGER = "5 - Bronze Manager";
    static SILVER_MANAGER = "6 - Silver Manager";
    static GOLD_MANAGER = "7 - Gold Manager";
    static DIRECTOR = "8 - Director";
    static REGIONAL_DIRECTOR = "9 - Director Regional";
    static GLOBAL_DIRECTOR = "10 - Director Global";

    static ranks = {
        OGA_OWNER: Rank.OGA_OWNER,
        VISIONARY:  Rank.VISIONARY,
        ENTERPRISING: Rank.ENTERPRISING,
        EXECUTIVE:  Rank.EXECUTIVE,
        MANAGER: Rank.MANAGER,
        BRONZE_MANAGER: Rank.BRONZE_MANAGER,
        SILVER_MANAGER: Rank.SILVER_MANAGER,
        GOLD_MANAGER: Rank.GOLD_MANAGER,
        DIRECTOR: Rank.DIRECTOR,
        REGIONAL_DIRECTOR: Rank.REGIONAL_DIRECTOR,
        GLOBAL_DIRECTOR: Rank.GLOBAL_DIRECTOR,
    };

    static instance;
    static getInstance() {
        if (!Rank.instance){
            Rank.instance = new Rank();
        }
        return Rank.instance;
    }

    static getByName(type){
        return Rank.ranks[type];
    }
}


// WEBPACK FOOTER //
// ./src/constants/Rank.jsx